<template>
    <section>
        <v-toolbar flat dense color="blue-grey lighten-5" class="report_bar">
            <v-toolbar-title>
                Staff
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-btn @click="openDialog" v-if="notLoggedUsers.length > 0" icon color="accent-2" class="blue--text">
                <v-icon>mdi-account-clock-outline</v-icon>
            </v-btn>

        </v-toolbar>

        <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="600px">
            <v-card color="lighten-1">
                <v-card-text>
                    <v-container>
                        <v-form ref="form" v-model="valid">
                            <v-row>
                                <v-col cols="12" md="12">

                                    <v-select v-if="editedIndex === -1" v-model="editedItem.user_id" :items="notLoggedUsers"
                                        item-text="name" item-value="id" placeholder="Select someone" :rules="nameRules">

                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" md="6">
                                    <v-text-field label="Start Time" v-model="editedItem.start_time"
                                        type="time"></v-text-field>
                                </v-col>
                                <v-col cols="6" md="6">

                                    <v-text-field label="End Time" v-model="editedItem.end_time" type="time"></v-text-field>
                                </v-col>

                            </v-row>
                            <v-row>
                                <v-col cols="6" md="6">
                                    <v-text-field label="Break" v-model.number="editedItem.break" type="number"
                                        hint="enter time in min" persistent-hint></v-text-field>
                                </v-col>
                                <v-col cols="6" md="6">
                                    <v-text-field label="Not Working/Down Time" v-model.number="editedItem.notworking"
                                        type="number" hint="enter time in min" persistent-hint></v-text-field>
                                </v-col>

                            </v-row>

                            <v-row>
                                <v-col cols="12" md="12">

                                    <v-autocomplete multiple chips v-model="editedItem.tasks" :items="user_tasks"
                                        item-text="name" item-value="id" placeholder="Type in" label="Completed tasks"
                                        hide-no-data prepend-icon="mdi-magnify" :rules="nameRules" :return-object="false">
                                    </v-autocomplete>
                                    <v-text-field label="Other" v-model="editedItem.other" persistent-hint
                                        hint="Any other tasks not listed above"></v-text-field>


                                </v-col>
                            </v-row>

                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" type="submit" @click="save" :disabled="!valid || isSubmited">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-data-table :headers="headers" :items="wages" :items-per-page="10" class="elevation-1">
            <template v-slot:item.actions="{ item }">
                <v-btn icon small @click="edit(item)">
                    <v-icon center>mdi-pencil</v-icon>
                </v-btn>
            </template>

            <template v-slot:item.tasks="{ item }">

                <template v-for="task in item.tasks">
                    <span>{{ task.name }}</span>&nbsp;
                </template>
                <p>{{ item.other }}</p>
            </template>

        </v-data-table>
    </section>
</template>

<script>
import { mapState } from 'vuex'
export default {

    data() {
        return {
            dialog: false,
            valid: true,

            headers: [
                { text: 'Name', align: 'start', sortable: true, value: 'user.name', },
                { text: 'Start Time', align: 'start', sortable: true, value: 'start_time', },
                { text: 'Finish Time', align: 'start', sortable: true, value: 'end_time', },
                { text: 'Break', align: 'start', sortable: true, value: 'break' },
                { text: 'Not working/DownTime', align: 'start', sortable: true, value: 'notworking' },
                { text: 'Completed Tasks', align: 'start', sortable: true, value: 'tasks' },
                { text: '', align: 'start', sortable: true, value: 'actions' },
            ],

            editedIndex: -1,
            editedItem: {
                user_id: null,
                start_time: null,
                end_time: null,
                break: 0,
                notworking: 0,
                tasks: [],
                workDate: '',
                other: ''
            },

            nameRules: [
                v => !!v || 'Required',
            ],

            isSubmited: false

        }
    },



    computed: {
        ...mapState(['wages', 'users', 'currentDate']),

        user_tasks() {

            let user_id = this.editedItem.user_id,

                userInd = this.users.findIndex(function (u) {
                    return u.id == user_id
                })

            return user_id ? this.users[userInd].tasks.filter(function (t) {
                return t.type !== 'auto'
            }) : []

        },



        notLoggedUsers() {

            let loggedUserIds = this.wages.map(function (w) {

                return w.user.id

            })


            return this.users.filter(function (u) {

                return !loggedUserIds.includes(u.id) && u.status == 1

            })
        }




    },

    mounted() {

        this.$store.dispatch('fetchWagesReportbyDate', 'today')

        if (this.users.length == 0)
            this.$store.dispatch('fetchUsers')

    },


    methods: {

        edit(item) {

            this.editedIndex = this.wages.indexOf(item)

            this.editedItem = Object.assign({}, item)
            this.dialog = true
            this.editedItem.tasks = item.tasks.map(function (t) {
                return t.id
            })
        },

        openDialog() {


            if (this.users.length === 1) {
                this.editedItem.user_id = this.users[0].id
            }

            this.dialog = true


        },

        close() {
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1

            })
        },


        save() {

            this.editedItem.workDate = this.currentDate
            this.isSubmited = true
            if (this.editedIndex > -1) {

                axios.put('/api/wages/' + this.editedItem.id, this.editedItem)
                    .then(response => {

                        //Object.assign(this.wages[this.editedIndex], this.editedItem)
                        this.$store.dispatch('fetchWagesReportbyDate', this.currentDate)
                        this.close()

                    })
                    .catch(err => {
                        console.log(err)
                    })


            } else {


                axios.post('/api/wages', this.editedItem)
                    .then(response => {

                        this.$store.dispatch('fetchWagesReportbyDate', this.currentDate)

                        //this.wages.push(this.editedItem)

                        this.close()

                    })
                    .catch(err => {
                        console.log(err)
                    })

            }

        },
    }
}
</script>
